// https://github.com/tailwindlabs/prettier-plugin-tailwindcss?tab=readme-ov-file#sorting-classes-in-template-literals
/**
 * This function allows the linter/formatter to recognize Tailwind classes in tagged template strings
 * @example
 * const myStyles = tw`bg-primary text-neutral`;
 */
export default (strings: TemplateStringsArray, ...values: string[]) =>
  String.raw({ raw: strings }, ...values);
